import { useEffect, useMemo, useState } from 'react'

import { Tab } from 'constants/types'

type Props = {
  tabs: Tab[]
  activeTab?: Tab['key']
  updateTrigger?: unknown
}

const useTabs = (props: Props) => {
  const {
    tabs: initialTabs = [],
    activeTab: initialActiveTab = '0',
    updateTrigger
  } = props

  const [tabs, setTabs] = useState(initialTabs)
  const [activeTab, setActiveTab] = useState(initialActiveTab)

  useEffect(() => {
    // no need to trigger update if value is not set
    if (updateTrigger !== undefined) {
      setTabs(initialTabs)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTrigger])

  const state = useMemo(
    () => ({
      tabs,
      activeTab
    }),
    [activeTab, tabs]
  )
  const actions = useMemo(() => ({ setTabs, setActiveTab }), [])

  return { state, actions }
}

export type TabsReturnType = ReturnType<typeof useTabs>
export type TabsReturnState = ReturnType<typeof useTabs>['state']
export type TabsReturnActions = ReturnType<typeof useTabs>['actions']

export default useTabs
